import { FC, ReactNode } from 'react'
import { Frame } from '../Frame'
import { Labels, LabelsProps } from './Labels'
import { ThumbnailWithLink, ThumbnailWithLinkProps } from './Thumbnail'
import { Outlines, OutlinesProps } from './Outlines/Outlines'

export interface CemeteryTinyItemProps extends OutlinesProps {
  header?: ReactNode
  leftContent?: ReactNode
  rightContent?: ReactNode
  footer?: ReactNode
  thumbnail?: Omit<ThumbnailWithLinkProps, 'cemeteryId'>
  labels?: LabelsProps['labels']
}

export const CemeteryTinyItem: FC<CemeteryTinyItemProps> = (props) => {
  const {
    header,
    rightContent,
    leftContent,
    footer,
    thumbnail,
    labels,
    cemeteryId,
    name,
    purchasePrice,
    review,
    area
  } = props

  return (
    <Frame
      header={header ?? null}
      leftContent={
        leftContent ??
        (thumbnail && (
          <ThumbnailWithLink {...thumbnail} cemeteryId={cemeteryId} />
        ))
      }
      rightContent={
        rightContent ?? (
          <Outlines
            cemeteryId={cemeteryId}
            name={name}
            review={review}
            area={area}
            purchasePrice={purchasePrice}
          />
        )
      }
      footer={footer ?? (labels && <Labels labels={labels} />)}
    />
  )
}
